import {FilterAgeGenderIcon, FilterCountryLanguageIcon} from '@/assets/icons/icons'
import {HostFiltersType} from '../types'
import {FilterItem} from '@/components/commons/selected-filters-list/SelectedFiltersList'

export const remapHostActiveFilters = (filters: HostFiltersType): FilterItem[] => {
    const remappedCountries =
        filters?.countries.map(item => ({
            label: item.name,
            id: item.id,
            icon: <FilterCountryLanguageIcon />
        })) || []

    const remappedLanguages =
        filters?.languages.map(item => ({
            label: item.name,
            id: item.id,
            icon: <FilterCountryLanguageIcon />
        })) || []

    const remappedGenders =
        filters?.genders?.map(item => ({
            label: item.name,
            id: item.id,
            icon: <FilterAgeGenderIcon />
        })) || []

    return [...remappedGenders, ...remappedCountries, ...remappedLanguages]
}

export const getActiveFiltersIds = (filters: HostFiltersType) => {
    if (!filters) return {}

    const genders_ids = filters?.genders?.length ? filters.genders.map(item => item.id) : undefined
    const languages_ids = filters.languages.length ? filters.languages.map(item => item.id) : undefined
    const countries_ids = filters.countries.length ? filters.countries.map(item => item.id) : undefined

    return {
        genders_ids,
        languages_ids,
        countries_ids,
        from_age: filters.fromAge || undefined,
        to_age: filters.toAge || undefined
    }
}

export const getActiveFiltersIdsV3 = (filters: HostFiltersType) => {
    if (!filters) return {}

    const gendersIds = filters?.genders?.length ? filters.genders.map(item => item.id) : undefined
    const languagesIds = filters.languages.length ? filters.languages.map(item => item.id) : undefined
    const countriesIds = filters.countries.length ? filters.countries.map(item => item.id) : undefined

    return {
        gendersIds,
        languagesIds,
        countriesIds,
        fromAge: filters.fromAge || undefined,
        toAge: filters.toAge || undefined
    }
}
